module.exports = __webpack_public_path__ + "media/photo/electric2-7b9bc20d.jpg";